module.exports = __webpack_public_path__ + "img/product-icon7.8b2c03b8.png";